// extracted by mini-css-extract-plugin
export default {"dropdown":"ProfileDropDown_dropdown__TMgyM"};